<div class="container-fluid">
  <div class="row">
    <div class="col-10">
      <app-e-forms-generator [indexPage]="indexPage"  [validationIndex]="validationIndex" [noticeTypeBh]="noticeTypeBh" [currentJson]="currentJson"
                             [formGroup]="eformsFormGroup" [linkForRouter]="linkForRouter"></app-e-forms-generator>
    </div>
  </div>
</div>
